(() => {
  const containers = Array.from(document.querySelectorAll('.animation-container'));
  const offset = 600;

  if (containers.length === 0) return;

  function throttle(callback, limit) {
    let tick = false;
    return () => {
      if (!tick) {
        callback.call();
        tick = true;
        setTimeout(() => {
          tick = false;
        }, limit);
      }
    };
  }

  function scrollHandler() {
    containers.forEach(container => {
      const top = container.offsetTop;
      const bottomOffset = top + container.offsetHeight;

      if (window.scrollY > top - offset && window.scrollY < bottomOffset) {
        const tiles = Array.from(container.querySelectorAll('.animation-float'));
        const transformY = Math.max(0, (window.scrollY - top + offset)) * 0.04;

        tiles.forEach(tile => {
          tile.style.transform = `translateY(-${transformY * parseInt(tile.getAttribute('data-animation-length'), 10)}px)`;
        });
      }
    });
  }

  window.addEventListener('scroll', throttle(scrollHandler, 100));
})();
